import { ShirtShieldProps, MakeOptional } from '@/types';

type Props = MakeOptional<ShirtShieldProps, 'startColor' | 'endColor'>;

export const ShieldClub = ({ startColor, endColor }: Props) => {
  const id = Math.floor(Math.random() * 1000);
  return (
    <svg
      enableBackground="new 0 0 200 215.4"
      id={`svg--shield__key--${String(id)}`}
      viewBox="0 0 200 215.4"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <linearGradient
        gradientTransform="matrix(1 0 0 -1 86.4 1116.4524)"
        gradientUnits="userSpaceOnUse"
        id={`shield__key--${id}`}
        x1="-78.4106"
        x2="69.6276"
        y1="923.0871"
        y2="1109.4462"
      >
        <stop offset="0" style={{ stopColor: `${startColor}` || '#ffffff' }} />
        <stop
          offset="0.9062"
          style={{ stopColor: `${endColor}` || '#ffffff' }}
        />
      </linearGradient>
      <path
        d="M21.5,142.6C-2.2,101.6-1.6,51.8,1.6,32l50-32
	c6.3,6.7,24.9,20.2,49,20.7c24.1,0.4,42.7-13.6,49-20.7l49.5,32c0.7,21.3,5.9,63.5-18.8,110.5c-19,36.2-60.1,64-79.6,72.8
	C84.1,208.2,45.2,183.5,21.5,142.6z"
        fill={`url(#shield__key--${id})`}
      />
    </svg>
  );
};
